import {
  StyleSheet,
  Text,
  View,
  ActivityIndicator,
  Modal,
  AppState,
  PixelRatio,
  Dimensions,
  ScrollView,
} from "react-native";
import React, { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import Colours from "../../utils/Colours";
import { TouchableOpacity } from "react-native";
import CustomerVerificationScreen from "./CustomerVerificationScreen";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import Toast from "react-native-toast-message";
import toastConfig from "../../toasts/toastConfig";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import VerifyEmail from "../loginScreen/VerifyEmail";
import NoticeAlertComp from "../../alertComp/NoticeAlertComp";
import { Image } from "expo-image";
import { useNavigation } from "@react-navigation/native";

const { width, height } = Dimensions.get("window");
const dpr = Math.round(PixelRatio.get() || 1);
const VAL_NAME = "dxfdmlk0f";
const MAX_RETRIEZ = 20;
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const dynamicThumbnailWidth = Math.round((width / BASE_WIDTH) * 100);
const dynamicThumbnailHeight = Math.round((width / BASE_WIDTH) * 100);

const CreateWalletScreenBuyMeeza = ({ setIsVerified, isVerified, isEmailVerified }) => {
  const { firstname, lastname, phonenumber, email, image } = useAuth();
  const [countdown, setCountdown] = useState(120);
  const [expirationTime, setExpirationTime] = useState(null);
  //const [isVerified, setIsVerified] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [noticeMessage, setNoticeMessage] = useState("");
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [isVerifyEmailVisible, setIsVerifyEmailVisible] = useState(false);
  const [complianceNotice, setShowComplianceNotice] = useState(false);
  const [showBodyTableCreditCategory, setShowBodyTableCreditCategory] = useState(false);
  const [useAvailableCredits, setUseAvailableCredit] = useState(false);
  // const [isVerifyButtonVisible, setIsVerifyButtonVisible] = useState(false)

  const [retryCount, setRetryCount] = useState(0);
  const [imageKey, setImageKey] = useState(0);

  const axiosPrivate = useAxiosPrivate();

  const navigation = useNavigation();

  console.log("isEmailVerified", isEmailVerified);

  //const [showCustomerVerificationScreen, setShowCustomerVerificationScreen] = useState(false)

  const getOptimizedCloudinaryUrl = (originalUrl, targetWidth, targetHeight) => {
    if (!originalUrl || !originalUrl.includes(VAL_NAME)) {
      return originalUrl;
    }

    //console.log('topHeader', targetHeight)
    //console.log('topHeaderW', targetWidth)

    // The 'transformations' string includes the optimization flags
    const transformations = `w_${targetWidth},h_${targetHeight},c_fill,f_auto,q_90,dpr_${dpr}`;

    // Inject the transformations into the URL
    return originalUrl.replace(/upload\//, `upload/${transformations}/`);
  };

  const handleImageError = () => {
    if (retryCount < MAX_RETRIEZ) {
      // Increment the retry counter
      setRetryCount((prevCount) => prevCount + 1);

      // Force component re-render by changing the key
      setImageKey((prevKey) => prevKey + 1);

      //console.log(`Image failed to load. Retrying... Attempt ${retryCount + 1}`);
    } else {
      // Log final failure or set a state to show a permanent fallback icon
      //console.error('Image failed to load after maximum retries.');
    }
  };

  const newUserProfileThumbnailUrl = getOptimizedCloudinaryUrl(
    image,
    dynamicThumbnailWidth,
    dynamicThumbnailHeight,
  );

  useEffect(() => {
    const checkEmailVerifyStatus = async () => {
      setIsLoadingButton(true);
      try {
        const response = await axiosPrivate.get("/isEmailVerified/isEmailVerified");

        // Handle success response
        if (response.status === 200 || response.status === 201) {
          setIsVerified(response.data.isEmailVerified);
          //console.log('Verification status', response.data.isEmailVerified)
          // Use response.data.customerId if needed for further processing
        }
      } catch (error) {
        //console.log('error', error)
      } finally {
        setIsLoadingButton(false);
      }
    };
    checkEmailVerifyStatus();
  }, [isVerified]);

  useEffect(() => {
    let timer;
    if (isVerifyEmailVisible) {
      const expireAt = Date.now() + 120 * 1000; // Set expiration time
      setExpirationTime(expireAt);
      updateCountdown(expireAt);

      timer = setInterval(() => updateCountdown(expireAt), 1000);
    }

    return () => clearInterval(timer);
  }, [isVerifyEmailVisible]);

  useEffect(() => {
    const handleAppStateChange = (nextAppState) => {
      if (nextAppState === "active" && expirationTime) {
        updateCountdown(expirationTime);
      }
    };

    const subscription = AppState.addEventListener("change", handleAppStateChange);
    return () => subscription.remove();
  }, [expirationTime]);

  const updateCountdown = (expireAt) => {
    const remaining = Math.max(0, Math.floor((expireAt - Date.now()) / 1000));
    setCountdown(remaining);

    if (remaining === 0) {
      setIsVerifyEmailVisible(false); // Close modal
      setCountdown(120);
    }
  };

  const handleshowMeezaCredit = () => {
    // setUseAvailableCredit(false);
    // setShowBodyTableCreditCategory(true);
    navigation.navigate("meezaCreditCategory", { useAvailableCredits });
  };

  const handleSendEmailOTP = async () => {
    setIsLoading2(true);
    try {
      // Make the axios POST request to the backend
      const response = await axiosPrivate.post("/sendEmailOTP/sendEmailOTP", { email });

      // Handle success response
      if (response.status === 200 || response.status === 201) {
        //console.log('OTP Sent:', response.data.message);
        setIsVerifyEmailVisible(true);
        // Use response.data.customerId if needed for further processing
      } else {
        //console.error('Unexpected response:', response);
        setErrorMessage("Email verification error");
        setIsErrorCompVisible(true);
      }
    } catch (error) {
      if (error.response) {
        //console.error('Error response from server:', error.response.data);
        setErrorMessage(error.response.data.message);
        setIsErrorCompVisible(true);
      } else if (error.request) {
        //console.error('No response received:', error.request);
      } else {
        //console.error('Error setting up the request:', error.message);
      }
    } finally {
      setIsLoading2(false);
    }
  };

  return (
    <View style={styles.profileContainer2}>
      <View style={styles.profileHeaderContainer2}>
        {image ? (
          <Image
            key={imageKey}
            source={{ uri: newUserProfileThumbnailUrl }}
            style={[styles.userImage2, { backgroundColor: "#d6d4d4ff" }]}
            contentFit="cover"
            cachePolicy="disk"
            onError={handleImageError}
          />
        ) : (
          <Image
            source={require("../../../assets/profile_image_holder.jpg")}
            style={styles.userImage2}
          />
        )}
        <Text
          style={{
            color: Colours.DARKGRAY,
            fontSize: dynamicFontSize(15),
            marginTop: dynamicSpacing(10),
            fontFamily: "Sen-Bold",
          }}
        >
          {firstname}
        </Text>
        <Text
          style={{
            color: Colours.PRIMARY,
            fontSize: dynamicFontSize(15),
            fontFamily: "Sen-Medium",
          }}
        >
          {email}
        </Text>

        <Text
          style={{
            color: Colours.DARKLIGHTGRAY,
            fontSize: dynamicFontSize(17),
            marginTop: dynamicSpacing(25),
            fontFamily: "Sen-Regular",
            textAlign: "center",
          }}
        >
          Our in-app currency "Meeza Credit" is neccessary for all transactions on Meeza, proceed to
          buy Meeza Credits
        </Text>
        <TouchableOpacity
          style={[
            styles.button2,
            // { backgroundColor: isVerified ? Colours.PRIMARY : Colours.PRIMARY_LIGHT },
            { backgroundColor: isEmailVerified ? Colours.PRIMARY : Colours.PRIMARY_LIGHT },
          ]}
          onPress={handleshowMeezaCredit}
          // disabled={!isVerified}
          disabled={!isEmailVerified}
        >
          {isLoading ? (
            <ActivityIndicator size="small" color="white" />
          ) : (
            <Text style={{ fontSize: dynamicFontSize(15), color: "white", fontFamily: "Sen-Bold" }}>
              proceed
            </Text>
          )}
        </TouchableOpacity>

        {isLoadingButton ? (
          <View style={{ display: "flex", marginTop: dynamicSpacing(20) }}>
            <ActivityIndicator
              size="large"
              color={Colours.PRIMARY}
              style={{ marginBottom: dynamicSpacing(10) }}
            />
          </View>
        ) : // isVerified || isEmailVerified ? null : (
        isEmailVerified ? null : (
          <TouchableOpacity
            style={styles.button3}
            onPress={handleSendEmailOTP}
            disabled={isLoading2}
          >
            {isLoading2 ? (
              <ActivityIndicator size="small" color="white" />
            ) : (
              <Text
                style={{ fontSize: dynamicFontSize(15), color: "white", fontFamily: "Sen-Bold" }}
              >
                Verify Email
              </Text>
            )}
          </TouchableOpacity>
        )}
      </View>
      {/* 
            <Modal
                AnimationType='fade'
                visible={showCustomerVerificationScreen}
                onRequestClose={() => setShowCustomerVerificationScreen(false)}
            >
                <TopHeaderComponent headerText={'BVN Verification'} hideScreen={() => {
                    setShowCustomerVerificationScreen(false)
                    // setShowComplianceNotice(false)
                }} />
                <ScrollView
                    contentContainerStyle={{ flexGrow: 1, paddingBottom: 100, backgroundColor: Colours.LIGHTEST }}
                >

                    <View style={styles.componentStyle}>
                        <CustomerVerificationScreen
                            showVerifiedCustomer={showVerifiedCustomer}
                            setShowVerifiedCustomer={setShowVerifiedCustomer}
                            setShowCustomerVerificationScreen={setShowCustomerVerificationScreen}
                            hideWalletScreen={hideWalletScreen}
                            setHasDva={setHasDva}
                        />

                    </View>
                </ScrollView>

            </Modal> */}

      <Modal visible={isErrorCompVisible} transparent={true} animationType="fade">
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>
      {/* 
            <Modal
                visible={complianceNotice}
                transparent={true}
                animationType="fade"
                onRequestClose={() => setShowComplianceNotice(false)}
            >
                <NoticeAlertComp
                    message={noticeMessage}
                    isLoading={isLoading}
                    onCancel={() => setShowComplianceNotice(false)}
                    onClose={handleCreateCustomer}
                // onClose={() => {setShowCustomerVerificationScreen(true)}}
                />
            </Modal> */}

      <Modal
        visible={isVerifyEmailVisible}
        animationType="fade"
        onRequestClose={() => setIsVerifyEmailVisible(false)}
      >
        <VerifyEmail
          email={email}
          setIsVerified={setIsVerified}
          countdown={countdown}
          hideModal={() => {
            setIsVerifyEmailVisible(false);
            setCountdown(120);
          }}
          //code={code}
          // onClose={() => setIsErrorCompVisible(false)}
        />
      </Modal>

      <Toast config={toastConfig} />
    </View>
  );
};

const styles = StyleSheet.create({
  componentStyle: {
    backgroundColor: Colours.LIGHTEST,
    height: "100%",
  },

  profileContainer2: {
    padding: dynamicSpacing(30),
    backgroundColor: Colours.LIGHTEST,
  },
  profileHeaderContainer2: {
    display: "flex",
    // flexDirection: 'row',
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
    // paddingTop: 30 ,
    height: "80%",
    // backgroundColor: Colours.LIGHTGRAY
    // gap: 10,
  },
  userImage2: {
    width: dynamicSize(100),
    height: dynamicSize(100),
    borderRadius: dynamicSize(99),
  },
  button2: {
    display: "flex",
    borderRadius: dynamicSize(10),
    justifyContent: "center",
    marginTop: dynamicSpacing(20),
    alignItems: "center",
    height: dynamicSize(55),
    width: "100%",
    backgroundColor: Colours.PRIMARY,
  },
  button3: {
    display: "flex",
    borderRadius: dynamicSize(10),
    justifyContent: "center",
    marginTop: dynamicSpacing(20),
    alignItems: "center",
    height: dynamicSize(55),
    width: "100%",
    backgroundColor: Colours.DARKGRAY,
  },
});

export default CreateWalletScreenBuyMeeza;
